var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTirePressure(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M4.783 0c.263 0 .478.208.478.463v1.854a.447.447 0 0 1-.18.362C5.042 2.71.958 5.861.958 9.732c0 2.78 1.36 4.706 2.167 5.604.12.132.224.272.313.42h15.14c.09-.147.18-.29.3-.42a8.316 8.316 0 0 0 2.166-5.604c0-3.925-4.083-7.022-4.125-7.053a.442.442 0 0 1-.179-.362V.463A.47.47 0 0 1 17.217 0a.47.47 0 0 1 .479.463V2.1C18.555 2.793 22 5.82 22 9.732c0 3.117-1.511 5.228-2.406 6.212a1.779 1.779 0 0 0-.464 1.188v.478c0 .765-.644 1.39-1.434 1.39h-1.913a.47.47 0 0 1-.479-.463v-.464h-.956v.464a.47.47 0 0 1-.478.463h-1.913a.47.47 0 0 1-.479-.463v-.464h-.956v.464a.47.47 0 0 1-.479.463H8.13a.47.47 0 0 1-.478-.463v-.464h-.956v.464a.47.47 0 0 1-.479.463H4.304c-.79 0-1.434-.625-1.434-1.39v-.478a1.79 1.79 0 0 0-.479-1.188C1.496 14.95 0 12.813 0 9.732 0 5.858 3.45 2.799 4.304 2.1V.463c0-.255.215-.463.479-.463zm4.782.927h2.87v8.341h-2.87V.927zm0 9.732h2.87v2.78h-2.87v-2.78z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-5-5h32v29H-5z",
    mask: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTirePressure);
export default __webpack_public_path__ + "static/media/tire_pressure.7b48740dd7b2f64a8567d116e90dc960.svg";
export { ForwardRef as ReactComponent };